import { gql } from 'graphql-tag';

export const GLOBAL_SEARCH = gql`
  query GlobalSearch($query: String!) {
    globalSearch(query: $query) {
      assets {
        id
        name
        assetNumber
        labels
        status
      }
      maintenance {
        id
        title
        workflowStatus
      }
      parts {
        id
        name
        number
        currentStock
        orderStatus
      }
      suppliers {
        id
        name
        city
      }
      events {
        id
        name
        startsAt
        eventType
      }
      tickets {
        id
        title
        status
      }
    }
  }
`;

export type AssetSearchItem = {
  id: string;
  name: string;
  assetNumber?: string | null;
  labels?: string[] | null;
  status?: string | null;
};

export type MaintenanceSearchItem = {
  id: string;
  title: string;
  workflowStatus: string;
};

export type PartSearchItem = {
  id: string;
  name: string;
  number?: string | null;
  currentStock?: number | null;
  orderStatus?: string | null;
};

export type SupplierSearchItem = {
  id: string;
  name: string;
  city?: string | null;
};

export type EventSearchItem = {
  id: string;
  name: string;
  startsAt?: string | null;
  eventType?: string | null;
};

export type TicketSearchItem = {
  id: string;
  title: string;
  status: string;
};

export type InspectionSearchItem = {
  id: string;
  title: string;
  workflowStatus: string;
};

export type GlobalSearchResult = {
  assets: AssetSearchItem[];
  maintenance: MaintenanceSearchItem[];
  parts: PartSearchItem[];
  suppliers: SupplierSearchItem[];
  events: EventSearchItem[];
  tickets: TicketSearchItem[];
  inspection?: InspectionSearchItem[];
};
